<template>
  <div
    class="large-text-container"
    :class="[cms.align === 'left' ? 'left-align' : 'right-align']"
  >
    <grid class="grid--container">
      <grid-item>
        <SlideInView
          direction="up"
          slide-distance="100%"
          :threshold="0.1"
          :repeat="false"
          :duration="0.7"
        >
          {{ cms.text }}
        </SlideInView>
      </grid-item>
    </grid>
  </div>
</template>
<script>
export default {
  props: {
    cms: {
      type: Object,
      default() {
        return {}
      },
    },
    data() {
      return {
        align: 'left',
        text: '',
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.left-align {
  text-align: left;
}
.right-align {
  text-align: left;
}

.large-text-container {
  font-family: 'Druk', Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: 500;
  background-color: $white;
  line-height: 80%; /* 76.8px */
  width: 100%;
  font-size: 80px;
}

@include media-breakpoint-up(md) {
  .large-text-container {
    font-size: 300px;
    text-transform: uppercase;
  }
  .left-align {
    text-align: left;
  }
  .right-align {
    text-align: right;
  }
}
</style>
